import { styled, Box, Stack } from '@ltvco/refresh-lib/theme';

export const PageContainer = styled(Box)(({ theme }) => ({
  maxWidth: 930,
  marginInline: 'auto',
  padding: theme.spacing(3, 2),
  paddingTop: theme.spacing(3), // Add extra top padding for PromoBar
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1.5),
    paddingTop: theme.spacing(5), // Slightly less top padding on mobile
  },
  backgroundColor: theme.palette.background.paper,
  marginTop: 50,
}));

export const PromoBarsContainer = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,

  [theme.breakpoints.up('md')]: {
    position: 'inherit',
    top: 'inherit',
    left: 'inherit',
    right: 'inherit',
  },
}));

export const PromoBar = styled(Box)(({ theme }) => ({
  backgroundColor: '#ff4722',
  color: theme.palette.common.white,
  textAlign: 'center',
  fontWeight: 700,
  padding: theme.spacing(1.5),
  letterSpacing: 0.5,
  textTransform: 'uppercase',
  marginBottom: 0,
  zIndex: 1000,
  fontSize: '1.125rem',
  cursor: 'default',

  '&.skip-banner': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.common.black,
    textTransform: 'inherit',
  },

  a: {
    cursor: 'pointer',
  },
}));
